// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mosaic-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}
.mosaic-list li {
  width: 25%;
  padding: var(--spacer2);
}
@media screen and (max-width: 1200px) {
  .mosaic-list li {
    width: 33.33333%;
  }
}
@media screen and (max-width: 900px) {
  .mosaic-list li {
    width: 50%;
  }
}
@media screen and (max-width: 600px) {
  .mosaic-list li {
    width: 100%;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
